import { INIT_SUCCESS, INIT_FAIL, EVALUATION_SAVE_SUCCESS, EVALUATION_SAVE_FAIL } from "../actions/webEvaluation2";

const initialState = {
  grade: null,
  classNumber: null,
  number: null,
  name: null,
  title: null,
  gradeRange: null,
  item: []
};

const webEvaluation2 = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case INIT_SUCCESS:
      return {
        ...state,
        grade: payload.grade,
        classNumber: payload.classNumber,
        number: payload.number,
        gradeRange: payload.gradeRange,
        name: payload.name,
        title: payload.title,
        item: payload.item
      };
    case INIT_FAIL:
      return {
        ...state,
        error: payload.error
      };

    case EVALUATION_SAVE_SUCCESS:
      return {
        ...state
      };
    case EVALUATION_SAVE_FAIL:
      return {
        ...state,
        error: payload.error
      };
    default:
      return {
        ...state
      };
  }
};

export default webEvaluation2;
